/**
 * Shared demo financial figures — single source of truth (BUG-22).
 *
 * The payment-acceleration opportunity figure is shown in multiple demo
 * surfaces (onboarding step 6, dashboard welcome message, dashboard blocks).
 * It MUST come from this constant so the number can never diverge between
 * surfaces again. If/when this figure is computed from seeded invoices
 * (FR-30 seeded-data layer), compute it here — every consumer follows.
 */

/** Display figure for demo payment-acceleration opportunities, e.g. "$45K". */
export const DEMO_PAYMENT_ACCELERATION_FIGURE = '$45K';
